<div class="row align-bdaytext">
    <div *ngIf="showBirthdayContainer" class="col-12 birthday-mod-unit-container">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="&#226;&#156;&#133;Cake">
                <path id="Icon" fill-rule="evenodd" clip-rule="evenodd"
                      d="M7.9508 2.00224C8.06378 2.01663 8.1565 2.09841 8.18474 2.20855C8.3255 2.75765 8.63422 3.31955 8.85906 3.67986C9.24097 4.29191 8.92673 5.09415 8.26967 5.29166V5.83038C8.71979 5.88293 9.06908 6.26495 9.06908 6.7284V7.72041H11.9464C12.9647 7.72041 13.7902 8.5445 13.7902 9.56106V9.85139C13.7903 9.85643 13.7903 9.86148 13.7902 9.86653V12.2047H14.3888C14.5422 12.2047 14.6666 12.3288 14.6666 12.482C14.6666 13.4991 13.6539 14.2221 12.5451 14.2221H3.45475C2.34597 14.2221 1.33325 13.4991 1.33325 12.482C1.33325 12.3288 1.45762 12.2047 1.61103 12.2047H2.19342V10.5454V10.5454V9.56106C2.19342 8.5445 3.01893 7.72041 4.03725 7.72041H6.91362V6.7284C6.91362 6.26458 7.26347 5.88232 7.71411 5.83026V5.282C7.14025 5.04793 6.86025 4.41231 6.99046 3.82819C7.0769 3.4404 7.25015 3.01652 7.39604 2.69826C7.46988 2.5372 7.53852 2.3993 7.58881 2.30148C7.61398 2.25252 7.63461 2.21347 7.64908 2.18643L7.66599 2.15509L7.6706 2.14665L7.67188 2.14432L7.67242 2.14334C7.72747 2.04381 7.83783 1.98784 7.9508 2.00224ZM8.26967 4.67322V4.4874C8.26967 4.33426 8.1453 4.21011 7.99189 4.21011C7.83848 4.21011 7.71411 4.33426 7.71411 4.4874V4.62503C7.55273 4.45936 7.47534 4.20618 7.53275 3.94866C7.60115 3.64182 7.73882 3.29043 7.87122 2.9952C8.03636 3.38204 8.23532 3.72921 8.38751 3.97309C8.54212 4.22087 8.46553 4.51691 8.26967 4.67322ZM7.18794 8.27501L7.1914 8.27503H8.7913L8.79475 8.27501H11.9464C12.5948 8.27501 13.1314 8.75327 13.2214 9.37572C12.907 9.23128 12.6003 9.16111 12.3046 9.15211C11.8715 9.13894 11.4806 9.25744 11.1419 9.43733C10.4727 9.79283 9.98544 10.3997 9.72406 10.7816C9.60906 10.9496 9.42184 11.0515 9.22702 11.0532C8.02145 11.0638 7.24023 10.5848 6.80365 10.1969C6.41489 9.85153 5.84716 9.81075 5.4087 10.0756C4.75719 10.469 4.05195 10.5257 3.49651 10.4784C3.22 10.4548 2.9854 10.4058 2.82074 10.3629C2.79503 10.3562 2.77107 10.3496 2.74898 10.3434V9.56106C2.74898 8.8508 3.32576 8.27501 4.03725 8.27501H7.18794ZM8.51352 7.72041V6.7284C8.51352 6.53533 8.35674 6.37882 8.16333 6.37882H7.81937C7.62596 6.37882 7.46917 6.53533 7.46917 6.7284V7.72041H8.51352ZM12.2877 9.70645C12.5713 9.71508 12.8876 9.80035 13.2347 10.0102V12.2047H2.74898V10.9167C2.93119 10.9611 3.17148 11.0073 3.44924 11.031C4.07506 11.0843 4.91042 11.0247 5.69627 10.5501C5.93309 10.407 6.2335 10.4328 6.43431 10.6112C6.95133 11.0706 7.86101 11.6198 9.23191 11.6077C9.6174 11.6044 9.97032 11.4048 10.1827 11.0945C10.4268 10.7379 10.8524 10.2194 11.4029 9.92694C11.6741 9.78287 11.9698 9.69678 12.2877 9.70645ZM2.45988 12.7593H1.93412C2.09508 13.2496 2.67181 13.6675 3.45475 13.6675H12.5451C13.328 13.6675 13.9048 13.2496 14.0657 12.7593H13.5124V12.7595H2.4712L2.45988 12.7593Z"
                      fill="#7B1A27"/>
            </g>
        </svg>

        <button class="bday-text"
                (keypress)="initBirthdayRewardModUnits(userProfile, $event)"
           (click)="initBirthdayRewardModUnits(userProfile, $event)" tabindex="0" role="link"
           aria-label="Add your birthday to get a special offer">
            Add your birthday to get a special offer
        </button>

    </div>
</div>
<div id="birthday-mod-unit-modal" aria-modal="true" class="modal fade" role="dialog" aria-labelledby=""
     aria-describedby="" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog  mw-100" role="document">
        <div class="modal-content modal-md">
            <div class="modal-container">
                <!-- Modal Header -->
                <div class="modal-header border-0">
                    <button tabindex="0" id="bdaymodelclose" aria-label="Birth day setup dialog close"
                            data-dismiss="modal" class="modal-x standard-x" setopenfocus>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <!-- Modal Body -->
                <div class="modal-body">
                    <div class="row">
                        <img class="initial-image"
                             src="{{appHostURL}}/etc/designs/wcax-commons/images/icons/birthday-treat-cupcake.png"
                             alt="smiling cupcake"/>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12 text-center modal-header-line">
                            <p>Get a little treat on your birthday, on us</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-center modal-sub-line">
                            <p>Add your birthday below</p>
                        </div>
                    </div>

                    <form id="birthdayModalForm" class="birthday-modal-form needs-validation mb-5"
                          data-focus="false" data-idp="false" method="patch"
                          role="form" data-toggle="validator">
                        <div class="row">
                            <div class="col-12">
                                <div role="region" aria-label="Error Message Block">
                                    <div id="error-message"
                                         class="help-block instructionalText errorMessage body-s">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-12 col-lg-7 col-md-7 ">
                                <div class="form-group">
                                    <label for="dob-month" class="label-email">Month</label>
                                    <select class="form-control" name="dob-month" id="dob-month"
                                            aria-describedby="month_err" required>
                                        <option value="" disabled selected>Month</option>
                                        <option value="1" data-days="31">January</option>
                                        <option value="2" data-days="29">February</option>
                                        <option value="3" data-days="31">March</option>
                                        <option value="4" data-days="30">April</option>
                                        <option value="5" data-days="31">May</option>
                                        <option value="6" data-days="30">June</option>
                                        <option value="7" data-days="31">July</option>
                                        <option value="8" data-days="31">August</option>
                                        <option value="9" data-days="30">September</option>
                                        <option value="10" data-days="31">October</option>
                                        <option value="11" data-days="30">November</option>
                                        <option value="12" data-days="31">December</option>
                                    </select>
                                    <small class="invalid-feedback" id="month_err" aria-live="polite">Select
                                        month</small>
                                </div>
                            </div>
                            <div class="col-12 col-lg-5 col-md-5 ">
                                <div class="form-group">
                                    <label for="dob-day" class="label-email">Day</label>
                                    <select disabled class="form-control disable" name="dob-day" id="dob-day"
                                            aria-describedby="day_err" required>
                                        <option value="" disabled selected>Day</option>
                                    </select>
                                    <small class="invalid-feedback" id="day_err" aria-live="polite">Select
                                        day</small>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-12">
                                <button *ngIf="!apiInProgress" tabindex="0" id="bdaymodelconfirmbtn" name="bdaymodel-confirm"
                                        class="btn btn-default modal-button" type="submit">Confirm
                                </button>
                                <span class="reward-btn__qty-step__amt" *ngIf="apiInProgress">
                                        <div class="small progress" alt="Loading..."><div class="prog1"><div class="prog2"></div></div></div>
                                    </span>
                            </div>
                        </div>
                    </form>

                </div>

            </div>
        </div>
    </div>
</div>
<div id="birthday-success-mod-unit-modal" aria-modal="true" class="modal fade" role="dialog" aria-labelledby=""
     aria-describedby="" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog  mw-100" role="document">
        <div class="modal-content modal-md">
            <div class="modal-container">
                <!-- Modal Header -->
                <div class="modal-header border-0">
                    <button tabindex="0" id="bdaysuccessclose" aria-label="Birth day setup success dialog close"
                            data-dismiss="modal" class="modal-x standard-x" setopenfocus>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <!-- Modal Body -->
                <div class="modal-body">

                    <div class="row">
                        <img class="initial-success-image"
                             src="{{appHostURL}}/etc/designs/wcax-commons/images/icons/success-banner-celebration.png"
                             alt="celebration image"/>
                    </div>
                    <div class="success-modal-message pb-5">
                        <div class="row">
                            <div class="col-12 text-center modal-header-line">
                                <p>We’ve marked our calendars</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center modal-sub-line">
                                <p>During your birthday month, enjoy a treat on us. You can use it on any
                                    purchase.</p>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-12">
                                <button tabindex="0" id="bdaymodelsuccessbtn" name="bdaymodel-success"
                                        class="btn btn-default modal-button" data-dismiss="modal" type="button">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
